import { render, staticRenderFns } from "./JyPense.vue?vue&type=template&id=570e1f2c&scoped=true&"
import script from "./JyPense.vue?vue&type=script&lang=ts&"
export * from "./JyPense.vue?vue&type=script&lang=ts&"
import style0 from "./JyPense.vue?vue&type=style&index=0&id=570e1f2c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "570e1f2c",
  null
  
)

export default component.exports